module.exports = __webpack_public_path__ + "media/application/images/svgs/umbrella-84d009ac55141dd0209ffdab46c7bfe9.svg";